/**
 * @file Link atom — inline navigation compound family.
 * @description Structured atom: parts re-exported from the vendored Gluestack
 * family; the only sanctioned import path for app code (RFC §3).
 * @module components/atoms/Link
 */
export { UILink, Link, LinkText } from "@/components/ui/link";
